"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatShortDate = void 0;
const formatShortDate = (date) => {
    // format date e.g. 01 Jan 2021 without using moment.js
    if (!date)
        return "";
    const d = new Date(date);
    const day = d.getDate();
    const month = d.getMonth();
    const year = d.getFullYear();
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
    ];
    return `${day} ${monthNames[month]} ${year}`;
};
exports.formatShortDate = formatShortDate;
